import LucideGlyph from 'lucide-react/dist/esm/icons/calendar-days.mjs';
import type { JSX } from 'react';
import { Icon } from '@solidops/ui/icon';
import type { IconProps } from '@solidops/ui/icon';

export function CalendarDaysIcon(props: IconProps): JSX.Element {
  return <Icon glyph={LucideGlyph} size={24} {...props} />;
}
